/**
 * 时间日期工具类
 */
import moment from 'moment';

export default {
  /**
   * 获取本周周一和周日日期
   */
  getCurrentWeek() {
    const start = moment()
      .weekday(1)
      .format('YYYY-MM-DD'); // 本周一
    const end = moment()
      .weekday(7)
      .format('YYYY-MM-DD'); // 本周日
    return [start, end];
  },

  /**
   * 获取前 i 周的周一和周日日期，并以数组的方式返回。
   * 当 i=1，获取的是上周一和上周日的日期；
   * 当 i=2，获取的是上上周一和上上周日的日期
   * ...以此类推
   * @param i
   */
  getLastWeek(i) {
    let weekOfDay = parseInt(moment().format('E'), 10); // 计算今天是这周第几天
    let lastMonday = moment()
      .subtract(weekOfDay + 7 * i - 1, 'days')
      .format('YYYY-MM-DD'); // 周一日期
    let lastSunday = moment()
      .subtract(weekOfDay + 7 * (i - 1), 'days')
      .format('YYYY-MM-DD'); // 周日日期
    return [lastMonday, lastSunday];
  },

  getLastWeekDuration(i) {
    let weekOfDay = parseInt(moment().format('E'), 10); // 计算今天是这周第几天
    let lastMonday = moment()
      .subtract(weekOfDay + 7 * i - 1, 'days')
      .format('YYYY-MM-DD'); // 周一日期
    let lastSunday = moment()
      .subtract(weekOfDay + 7 * (i - 1), 'days')
      .format('YYYY-MM-DD'); // 周日日期

    let duration = [];
    let count = 0;
    while (this.setDate(new Date(lastMonday).getTime(), count) !== lastSunday) {
      duration.push(this.setDate(new Date(lastMonday).getTime(), count));
      count++;
    }
    duration.push(lastSunday);
    return duration;
  },

  setDate(date = Number(new Date()), offset = 0) {
    const oneDay = 24 * 60 * 60 * 1000;
    let offsetDate = new Date(date + offset * oneDay);
    return this.formatDate(offsetDate);
  },
  formatDate(date) {
    const [Y, M, D] = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
    const dt = `${[Y, M, D].map(this.addZero).join('-')}`;
    return `${dt}`;
  },
  addZero(num) {
    return (num > 9 ? '' : '0') + num;
  },

  /**
   * 获取后 i 周的周一和周日日期，并以数组的方式返回。
   * 当 i=1，获取的是下周一和下周日的日期；
   * 当 i=2，获取的是下下周一和下下周日的日期
   * ...以此类推
   * @param i
   */
  getNextWeek(i) {
    let weekOfDay = parseInt(moment().format('E'), 10); // 计算今天是这周第几天
    let nextMonday = moment()
      .add(7 - weekOfDay + 7 * (i - 1) + 1, 'days')
      .format('YYYY-MM-DD'); // 周一日期
    let nextSunday = moment()
      .add(7 - weekOfDay + 7 * i, 'days')
      .format('YYYY-MM-DD'); // 周日日期
    return [nextMonday, nextSunday];
  },
};
